"use client";

import React from "react";
import { Box } from "@repo/ui/box";
import { Button } from "@repo/ui/button";
import * as Flex from "@repo/ui/flex";
import { GridLayoutOneIcon } from "@/theme/icons/grid-layout-1";
import { GridLayoutTwoIcon } from "@/theme/icons/grid-layout-2";
import { GridLayoutThreeIcon } from "@/theme/icons/grid-layout-3";
import { GridLayoutFourIcon } from "@/theme/icons/grid-layout-4";
import * as Viewport from "../viewport";
import { useGridLayout } from "./grid-layout-context";
import classes from "./grid-layout.module.css";

export const GridLayout = () => {
  const { setColumns, columns } = useGridLayout();

  return (
    <>
      <Viewport.Small>
        <Flex.Container>
          <Box paddingX="md" paddingY="md" asChild>
            <Button
              size="icon"
              onClick={() => setColumns(1)}
              alignment="center"
            >
              <GridLayoutOneIcon
                className={classes.icon}
                filled={columns === 1}
                label="1 column layout"
              />
            </Button>
          </Box>
          <Box paddingX="md" paddingY="md" asChild>
            <Button
              size="icon"
              onClick={() => setColumns(2)}
              alignment="center"
            >
              <GridLayoutTwoIcon
                className={classes.icon}
                filled={columns === 2}
                label="2 column layout"
              />
            </Button>
          </Box>
          <Box paddingX="md" paddingY="md" asChild>
            <Button
              size="icon"
              onClick={() => setColumns(3)}
              alignment="center"
            >
              <GridLayoutThreeIcon
                className={classes.icon}
                filled={columns === 3}
                label="3 column layout"
              />
            </Button>
          </Box>
        </Flex.Container>
      </Viewport.Small>
      <Viewport.Large>
        <Flex.Container>
          <Button size="icon" onClick={() => setColumns(2)} alignment="center">
            <GridLayoutTwoIcon
              className={classes.icon}
              filled={columns === 2}
              label="2 column layout"
            />
          </Button>
          <Button size="icon" onClick={() => setColumns(4)} alignment="center">
            <GridLayoutFourIcon
              className={`${classes.icon} ${
                columns === 4 ? classes["icon-filled"] : classes["icon-outline"]
              }`}
              filled={columns === 4}
              label="4 column layout"
            />
          </Button>
        </Flex.Container>
      </Viewport.Large>
    </>
  );
};
